export enum Relationship {
  Adoptive = 1,
  Agency = 2,
  Aunt = 3,
  Birth = 4,
  EmancipatedYouth = 5,
  FamilyFriend = 6,
  Father = 7,
  FosterParent = 8,
  FosterSurrogate = 9,
  GodParent = 10,
  Grandparent = 11,
  LegalPerson = 12,
  Mother = 13,
  Neighbor = 14,
  NonRelative = 15,
  OtherLegalGuardian = 16,
  OtherRelative = 17,
  ParentHasAssignTemporaryGuardianshipTo = 18,
  Parent = 19,
  Sibling = 20,
  StepParent = 21,
  SurrogateParent = 22,
  Title15A = 23,
  Uncle = 24,
  WardOfState = 25,
  CaseWorkerOrPlanner = 26,
}
